module.exports = __webpack_public_path__ + "img/stretch--genre4-img3.bb847089.jpg";